<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>生产日志</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item label="车间选择">
					<WorkshopSelect v-model="workshop" />
				</el-form-item>
				<el-form-item label="机台选择">
					<el-select v-model="device" placeholder="机台选择" style="width:150px">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">日志查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="tableList">
			<ProductionList v-show="action == 'search'" :action="action" :params="queryData" />
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import WorkshopSelect from '@/components/WorkshopSelect'
	import ProductionList from './ProductionList'
	export default {
		components: {
			DateRange,
			WorkshopSelect,
			ProductionList,
		},
		data() {
			return {
				dateRange: [],
				workshop: {},
				device: {},
				action: '',
			}
		},
		computed: {
			queryData() {
				var data = {
					dateStart: this.dateRange[0],
					dateEnd: this.dateRange[1],
					workshop: this.workshop,
					device: this.device,
				}

				return data
			},
		},
		watch: {
			dateRange(value) {
				console.log('dateRange', value)
			},
		},
		methods: {
			onSubmit() {
				this.action = 'search'
				console.log('submit!')
			},
		},
	}
</script>

<style></style>
